import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Checkbox, Select } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    unitTypeEventCreateRequest,
    unitTypeEventGetRequest,
    unitTypeEventEditRequest,
    searchEntityRequest,
} from 'Redux/actions';

const CreateEditUnitTypeEvent = (props) => {
    const { loadData, eventParam, unitTypeEvents, manufacturerParam, unitTypeParam } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRefUnitTypeEvent = useRef();

    const [manufacturer, setManufacturer] = useState(manufacturerParam || null);
    const [unitType, setUnitType] = useState(unitTypeParam || null);
    const [rawEvent, setRawEvent] = useState(null);
    const [active, setActive] = useState(false);
    const [event, setEvent] = useState(eventParam || null)
    const { openModal, loading, createUnitTypeEvent, updateUnitTypeEvent, currentUnitTypeEvent } = useSelector(state => state.createEditUnitTypeEventRedux);
    const { manufacturers, unitTypes, events } = useSelector(state => state.generalRedux);

    const closeModalCreateEditUnitEventType = () => {
        setManufacturer(null)
        setUnitType(null)
        setActive(false)
        setRawEvent(null)
        dispatch(clearRedux("UNITTYPE_EVENT_CREATE_EDIT"))
    }

    const applyChangesUnitTypeEvent = () => {
        let payload = {
            eventId: event?.id,
            unitTypeId: unitType?.id,
            rawEvent,
            active
        }
        if (currentUnitTypeEvent?.id) {
            payload.id = currentUnitTypeEvent?.id
            dispatch(unitTypeEventEditRequest(payload))
        } else dispatch(unitTypeEventCreateRequest(payload))
    }

    useEffect(() => {
        if (createUnitTypeEvent?.id) {
            NotificationManager.success(
                messages['unittype_event_create_success_message'],
                messages['unittype_event_create_title'],
                3000
            );
            closeModalCreateEditUnitEventType();
            loadData && loadData()
            dispatch(clearRedux("UNITTYPE_EVENT_CREATE_EDIT", { createUnitTypeEvent: null }))
        }

        if (updateUnitTypeEvent) {
            NotificationManager.success(
                messages['unittype_event_edit_success_message'],
                messages['unittype_event_edit_title'],
                3000
            );
            closeModalCreateEditUnitEventType();
            loadData && loadData()
            dispatch(clearRedux("UNITTYPE_EVENT_CREATE_EDIT", { updateUnitTypeEvent: null }))
        }

        if (currentUnitTypeEvent) {
            let unittype = unitTypes.find((item) => item.id === currentUnitTypeEvent?.unitTypeId)
            if (unittype.manufacturer) {
                setManufacturer(unittype.manufacturer)
                setUnitType(unittype)
            }
            setRawEvent(currentUnitTypeEvent?.rawEvent)
            setActive(currentUnitTypeEvent?.active)
            setEvent(events.find((item) => item.id === currentUnitTypeEvent?.eventId))

        }

    }, [createUnitTypeEvent, updateUnitTypeEvent, currentUnitTypeEvent])

    useEffect(() => {
        (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        (!unitTypes || unitTypes?.length === 0) && dispatch(searchEntityRequest({ key: "unitTypes" }));
        (!events || events.length === 0) && dispatch(searchEntityRequest({ key: "events" }));
    }, [])


    return (
        <Modal
            open={openModal}
            title={currentUnitTypeEvent?.id ? `${messages['unittype_event_edit_title']}` : messages['unittype_event_create_title']}
            handleClose={() => closeModalCreateEditUnitEventType()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <Form
                        ref={formRefUnitTypeEvent}
                        onValidSubmit={() => applyChangesUnitTypeEvent()}
                    >
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="events"
                                label={messages['unittype_event_event']}
                                placeholder={messages['unittype_event_event']}
                                options={events || []}
                                onChange={(value) => {
                                    if (unitTypeParam) {
                                        let exist = unitTypeEvents.find((item) => item.eventId === value.id && item.unitTypeId === unitType?.id)
                                        if (!exist)
                                            setEvent(value)
                                        else
                                            NotificationManager.warning(
                                                messages['unittype_event_already_exists'],
                                                messages['unittype_event_edit_title'],
                                                5000
                                            );
                                    } else
                                        setEvent(value)
                                }}
                                value={event || eventParam || null}
                                textField="name"
                                valueField="id"
                                required
                                requiredMessage={messages["common_field_required"]}
                                disabled={eventParam}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="manufacturer"
                                label={messages['unittype_event_manufacturer']}
                                placeholder={messages['unittype_event_manufacturer']}
                                options={manufacturers || []}
                                onChange={(value) => {
                                    setManufacturer(value)
                                    setUnitType(null)
                                }}
                                value={manufacturer}
                                textField="name"
                                valueField="id"
                                isClearable
                                required
                                requiredMessage={messages["common_field_required"]}
                                disabled={manufacturerParam}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="unittype"
                                label={messages['unittype_event_unit_type']}
                                placeholder={messages['unittype_event_unit_type']}
                                options={manufacturer && unitTypes.filter(item => item.manufacturerId === manufacturer?.id) || []}
                                onChange={(value) => {
                                    let exist = unitTypeEvents.find((item) => item.unitTypeId === value.id && item.eventId === event?.id)
                                    if (!exist)
                                        setUnitType(value)
                                    else
                                        NotificationManager.warning(
                                            messages['unittype_event_already_exists'],
                                            messages['unittype_event_edit_title'],
                                            5000
                                        );
                                }}
                                value={unitType}
                                textField="name"
                                valueField="id"
                                isClearable
                                required
                                requiredMessage={messages["common_field_required"]}
                                disabled={manufacturerParam}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Input
                                label={messages['unittype_event_raw_event']}
                                value={rawEvent}
                                onChange={(rawEvent) => {
                                    setRawEvent(rawEvent)
                                }}
                                maxLength={40}
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Checkbox
                                id="active"
                                label={messages['unittype_event_active']}
                                value={active}
                                onChange={(checked) => setActive(checked)}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModalCreateEditUnitEventType()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        formRefUnitTypeEvent?.current?.submit()
                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditUnitTypeEvent;